export const allUsersPath = ['allUsers'];
export const assignedUsersPath = ['roleDetails', 'assignedUsers', 'selectedUsers'];
export const pathLoaded = ['isAssignedUsersReady'];
export const updateUsersPath = ['assignedUsers', 'selectedUsers'];

// hidden users are support users
// hidden users are those users which are assigned to identity role but we should not show them on UI ( SSO Admin user )
// If they are assigned to some identity role then we should not accidentally delete them
export const hiddenUsersPath = ['roleDetails', 'assignedUsers', 'hiddenUsers'];
